<template>
  <div class="info-modal">
    <div class="info-modal__window">

      <div class="small-modal">
        <div class="small-modal__title" v-if="title">
          {{title}}
        </div>

        <slot />

        <div class="info-modal__actions small-modal__cta">
          <slot
            name="actions"
            classAction="info-modal__action"
          />
        </div>
        </div>

    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: '',
      },
    },
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .info-modal {
    position: fixed;
    z-index: 200;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color-black, 0.75);
    padding: 0 r(8);
  }

  .info-modal__window {
    @include card;
    max-width: r(480);
    background-color: $color-white;
    margin: r(32) auto;
    width: 80%;
  }

  .info-modal__actions {
    flex-wrap: wrap;
    margin-left: r(-12);
    margin-right: r(-12);
    margin-bottom: r(-24);
  }

  .info-modal__action {
    margin: 0 r(12) r(24);
  }
</style>
